<template>
  <div class="main" v-if="info">
    <div class="main_left">
      <ul class="main_tabs">
        <li :style="info.titleStyle" @click="moreClick(info)">{{ info.title }}</li>
        <li
          v-for="item in info.recommendList"
          :key="item.id"
          :style="info.recommendStyle"
          @click="movieClick(item, info)"
        >{{ item.name }}</li>
        <li :class="moreClass" :style="info.titleBtnStyle" @click="moreClick(info)">{{ sHrefText }}</li>
      </ul>
      <ul class="main_list" :style="info.isSeniority ? 'justify-content: space-between;' : ''">
        <li v-for="(item, index) in mainList" :key="index" v-show="!!item" :style="item ? item.style : ''">
          <img :src="item.img" @click="movieClick(item, info)" />
          <span class="total" v-if="item.total" :style="info.totalStyle">{{ item.total }}</span>
          <span class="title" v-if="isContent" :style="info.nameStyle" @click="movieClick(item, info)">{{ item.name }}</span>
          <span class="synopsis" :style="info.introStyle">{{ item.intro }}</span>
        </li>
      </ul>
    </div>
    <div class="main_right" v-if="info.list && info.list.length > 0 && info.isSeniority">
      <div class="main_tabs">TOP榜</div>
      <Seniority :info="info.seniorityInfo" @movieClick="seniorityClick" />
    </div>
  </div>
</template>

<script>
import Seniority from './Seniority.vue'

export default {
  name: 'ImageList',
  components: { Seniority },
  props: { info: Object },
  computed: {
    mainList() {
      return this.info.mainList || []
    },
    sHrefText() {
      return this.info.sHrefText || '更多 >'
    },
    moreClass() {
      return 'more'
    },
    isContent() {
      return this.info.isContent !== false
    }
  },
  methods: {
    moreClick(info) {
      this.$emit('moreClick', info)
    },
    movieClick(item) {
      this.$emit('movieClick', item)
    },
    seniorityClick(item) {
      this.$emit('movieClick', item)
    }
  }
}
</script>

<style lang="scss" scoped>

.main {
  display: flex;
  width: $content-width;
  margin: auto;
  margin-bottom: 52px;
  z-index: 8;
  position: relative;
}

.main_left {
  flex: 1;
  overflow: hidden;

  .main_tabs {
    display: flex;
    align-items: flex-end;
    font-family: PingFang;
    font-weight: 700;
    font-size: 14px;
    color: #333;
    margin-bottom: 15px;
    cursor: pointer;
    list-style: none;
    padding: 0;

    li {
      margin-right: 10px;
      padding-bottom: 5px;

      &:first-child {
        font-size: 30px;
        color: #000;
        margin-right: 27px;
        padding-bottom: 0;
        cursor: default;
      }

      &:last-child {
        color: #666;
        margin-left: 12px;
      }
    }
  }

  .main_list {
    display: flex;
    width: 100%;
    cursor: pointer;
    list-style: none;
    padding: 0;

    li {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-right: 20px;
      flex-shrink: 0;

      &:last-child {
        margin-right: 0;
      }

      img {
        width: 210px;
        height: 118px;
        border-radius: 5px;
      }

      .title {
        font-family: PingFang;
        font-weight: 400;
        font-size: 16px;
        color: #000;
        margin-top: 16px;
        padding: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 200px;
      }

      .synopsis {
        font-family: PingFang;
        font-weight: 400;
        font-size: 14px;
        color: #999;
        padding-left: 6px;
        line-height: 34px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 200px;
      }

      .total {
        display: block;
        font-size: 12px;
        color: $text-light;
        margin-top: 4px;
      }
    }
  }
}

.main_right {
  width: 270px;
  margin-left: 24px;

  .main_tabs {
    font-family: PingFang;
    font-weight: 700;
    font-size: 30px;
    color: #000;
    margin-left: 24px;
    margin-bottom: 16px;
  }
}
</style>
